import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "../../admin/AdminLayout";
import AdminAuthGuard from "../../admin/AdminAuthGuard";
import { api } from "../../api/client";
import { Sparkles, X } from "lucide-react";

const AdminEliteSubscriptions = () => {
    const [status, setStatus] = useState("active");
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        api.get(`/admin/elite/subscriptions?status=${status}`)
            .then((r) => { setItems(r.data.items || []); setTotal(r.data.total || 0); })
            .finally(() => setLoading(false));
    };
    useEffect(load, [status]); // eslint-disable-line

    const revoke = async (s) => {
        if (!window.confirm(`Revoke Elite for ${s.user_email}?`)) return;
        try {
            await api.post(`/admin/elite/subscriptions/${s.id}/revoke`);
            toast.success("Revoked");
            load();
        } catch { toast.error("Failed"); }
    };

    return (
        <AdminAuthGuard>
            <AdminLayout>
                <div className="mb-6 flex items-end justify-between gap-3">
                    <div>
                        <p className="label-uppercase text-zinc-500">Customers</p>
                        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-50">
                            <Sparkles className="h-5 w-5 text-amber-600" /> Elite members
                        </h1>
                        <p className="mt-1 text-xs text-zinc-500">{total} member(s) in this view</p>
                    </div>
                    <div className="flex gap-1.5">
                        {["active", "expired", "cancelled", "all"].map((s) => (
                            <button key={s} onClick={() => setStatus(s)} className={`rounded-full px-3 py-1 text-xs font-medium ${status === s ? "bg-amber-600 text-white" : "border border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50 dark:bg-white/5 dark:text-zinc-300"}`} data-testid={`admin-elite-tab-${s}`}>
                                {s}
                            </button>
                        ))}
                    </div>
                </div>

                {loading ? <p className="text-sm text-zinc-500">Loading…</p> : items.length === 0 ? (
                    <p className="rounded-2xl border border-dashed border-zinc-200 p-8 text-center text-sm text-zinc-500">No subscriptions in this view.</p>
                ) : (
                    <div className="overflow-hidden rounded-2xl border border-zinc-100 bg-white dark:border-white/10 dark:bg-white/[0.03]">
                        <table className="min-w-full text-sm" data-testid="admin-elite-table">
                            <thead className="bg-zinc-50 text-left text-xs uppercase tracking-wider text-zinc-500 dark:bg-white/5">
                                <tr>
                                    <th className="px-4 py-2">Member</th>
                                    <th className="px-4 py-2">Plan</th>
                                    <th className="px-4 py-2">Started</th>
                                    <th className="px-4 py-2">Expires</th>
                                    <th className="px-4 py-2">Status</th>
                                    <th className="px-4 py-2"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((s) => (
                                    <tr key={s.id} className="border-t border-zinc-100 dark:border-white/5">
                                        <td className="px-4 py-2">
                                            <p className="font-medium">{s.user_full_name || "—"}</p>
                                            <p className="text-xs text-zinc-500">{s.user_email}</p>
                                        </td>
                                        <td className="px-4 py-2 capitalize">{s.plan_slug}</td>
                                        <td className="px-4 py-2 text-xs text-zinc-500">{new Date(s.started_at).toLocaleDateString()}</td>
                                        <td className="px-4 py-2 text-xs text-zinc-500">{new Date(s.expires_at).toLocaleDateString()}</td>
                                        <td className="px-4 py-2">
                                            <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${s.status === "active" ? "bg-emerald-100 text-emerald-700" : "bg-zinc-100 text-zinc-600"}`}>
                                                {s.status}
                                            </span>
                                        </td>
                                        <td className="px-4 py-2">
                                            {s.status === "active" && (
                                                <button onClick={() => revoke(s)} className="inline-flex items-center gap-1 rounded-md border border-rose-200 px-2.5 py-1 text-xs font-medium text-rose-700 hover:bg-rose-50" data-testid={`admin-elite-revoke-${s.id}`}>
                                                    <X className="h-3 w-3" /> Revoke
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </AdminLayout>
        </AdminAuthGuard>
    );
};

export default AdminEliteSubscriptions;
